function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  fillRule: "evenodd",
  d: "M12.344 17.52a2.458 2.458 0 00.892-3.253l-1.813-3.41A2.457 2.457 0 008.1 9.841l-.07.037a2.457 2.457 0 00-1.016 3.324l.537 1.01a2.48 2.48 0 01.124-.07l.07-.037a2.457 2.457 0 013.324 1.016l1.275 2.399zM10 25a9 9 0 110-18 9 9 0 010 18zm2.344-7.48a1.88 1.88 0 01-.124.07l-.07.038a2.457 2.457 0 01-3.323-1.017L7.55 14.213a2.458 2.458 0 00-.892 3.253l1.813 3.408a2.457 2.457 0 003.323 1.016l.07-.037a2.457 2.457 0 001.016-3.324l-.537-1.01z"
});

function SvgAtm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default __webpack_public_path__ + "40cf0fe3364b4ad56405bbe78ba1a6cc.svg";
export { SvgAtm as ReactComponent };